import template from './prime-cost-plus-project-view.html';
import controller from './prime-cost-plus-project-view.controller';

let primeCostPlusProjectViewComponent = {
  restrict: 'E',
  bindings: {
    project: '<'
  },
  template,
  controller
};

export default primeCostPlusProjectViewComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/project-details/views/prime-cost-plus-project-view/prime-cost-plus-project-view.component.js